import React from "react";
import cn from "classnames";

import styles from "./pagination.module.scss";
interface PaginationCountProps {
  currentlyVisible: number;
  totalProductCount: number;
}

/**
 * PaginationCount component
 * @param {number} currentlyVisible - The number of products currently visible
 * @param {number} totalProductCount - The total number of products
 * @returns {React.ReactElement}
 */
const PaginationCount = React.memo(
  ({ currentlyVisible, totalProductCount }: PaginationCountProps) => {
    return (
      <p
        data-testid="pagination-count"
        className={cn(
          "view-count-text",
          "lll-text-body-1 lll-font-weight-medium",
          styles.indicator
        )}
      >
        {`Viewing ${Math.min(
          currentlyVisible,
          totalProductCount
        )} of ${totalProductCount}`}
      </p>
    );
  }
);

export default PaginationCount;

PaginationCount.displayName = "PaginationCount";
